import styled from 'styled-components';
import colors from 'styles/colors';

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
`;

const PaginationButton = styled.div`
  cursor: pointer;
  color: ${colors.highlight};
  transition: 0.15s ease-in-out;
  font-size: 14px;
  display: inline-block;

  &:hover {
    color: ${colors.highlightActive};
  }

  i {
    font-size: 12px;
  }
`;

export const PreviousButton = styled(PaginationButton)<{ disabled: boolean }>`
  margin-right: 20px;

  i {
    margin-right: 10px;
  }

  ${(props) =>
    props.disabled
      ? `
        cursor: initial;
        color: ${colors.highlightInactive};

        &:hover {
            color: ${colors.highlightInactive};
        }
    `
      : null};
`;

export const NextButton = styled(PaginationButton)<{ disabled: boolean }>`
  margin-left: 20px;

  i {
    margin-left: 10px;
  }

  ${(props) =>
    props.disabled
      ? `
        cursor: initial;
        color: ${colors.highlightInactive};

        &:hover {
            color: ${colors.highlightInactive};
        }
    `
      : null};
`;

export const PageNumber = styled(PaginationButton)<{ active?: boolean }>`
  padding: 0 5px;

  ${(props) =>
    props.active
      ? `
        background-color: ${colors.highlightInactive};
        color: ${colors.white};
    `
      : null};
`;
